module.exports = __webpack_public_path__ + "static/img/bio-lgchem.ae309f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/bio-lgchem.jpg
// module id = ACwl
// module chunks = 0